// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"123":"9bf5daf6","647":"ef381a6e"}[chunkId] + ".js";
};